import dayjs from 'dayjs'
import { DATE_TIME_FORMAT } from '@/const'
import GroupRepository from '@/repositories/GroupRepository'
import EventRepository from '@/repositories/EventRepository'
import MetaRepository from '@/repositories/MetaRepository'
import ProfileEntity from '@/entities/Profile'
import SchoolEntity from '@/entities/School'
import EventEntity from '@/entities/Event'
import ProfileRepository from '@/repositories/ProfileRepository'
import { IEventThumbnail } from '@/types/domain/event'
import { calcSchoolYear } from '@/utils/helper'

export interface IPresenterParams {
  groupRepository: GroupRepository
  eventRepository: EventRepository
  profileRepository: ProfileRepository
  groupId: number
  metaRepository: MetaRepository
}
export interface IPresenter {
  eventThumbnails: {
    [eventId: number]: Omit<IEventThumbnail, 'eventId'>
  }
  currentEventOfPublished: { data: EventEntity; school: SchoolEntity }[] | []
  serverTimestamp: string | null
  profile: ProfileEntity | null
}

export default ({ groupRepository, groupId, eventRepository, metaRepository, profileRepository }: IPresenterParams): IPresenter => {
  const schools = groupRepository.getSchools(groupId).reduce((acc, ac) => {
    acc[ac.props.year] = {
      ...acc[ac.props.year],
      [ac.props.id]: ac
    }
    return acc
  }, {} as Record<number, Record<number, SchoolEntity>>)
  const serverTimestamp = metaRepository.getLatestServerTimestamp()

  // dayjs(serverTimestamp, DATE_TIME_FORMAT).month() に + 1 する
  const currentSchoolYear = !serverTimestamp ? null : calcSchoolYear(dayjs(serverTimestamp, DATE_TIME_FORMAT).year(), dayjs(serverTimestamp, DATE_TIME_FORMAT).month() + 1)

  const eventsBySchools = groupRepository.getSchools(groupId).reduce((acc, ac) => {
    acc[ac.props.id] = eventRepository.getEventsByIds(ac.props.eventIds)
    return acc
  }, {} as { [schoolId: number]: { [eventId: number]: EventEntity } })

  const currentEventOfPublished: { data: EventEntity; school: SchoolEntity }[] = []
  if (currentSchoolYear && schools[currentSchoolYear]) {
    const currentYearSchools = Object.keys(schools[currentSchoolYear] || {}).map(Number)
    currentYearSchools.forEach((school: number) => {
      const targetEvents = eventsBySchools[school]
      for (const event of Object.values(targetEvents)) {
        if (event.props.publishStatus === 'publish') {
          currentEventOfPublished.push({
            data: event,
            school: schools[currentSchoolYear][school] // eslint-disable-line @typescript-eslint/no-non-null-assertion
          })
        }
      }
    })
  }

  const profile = profileRepository.getProfile()

  return {
    eventThumbnails: eventRepository.getEventThumbnails(),
    currentEventOfPublished,
    serverTimestamp,
    profile
  }
}
